import globalCn from './global/global-ru'
import loginCn from './login/login-ru'
import homeCn from './home/home-ru'
import deviceCn from './device/device-ru'
import logCn from './logs/log-ru'
import orgCn from './org/org-ru'
import alarmCn from './alarm/alarm-ru'
import superviseCn from './supervise/supervise-ru'
import menuCn from './menu/menu-ru'
import searchCn from './search/search-ru'
import columnCheck from './columnCheck/columnCheck-ru'
import setting from './setting/setting-ru'
const ru = {
  global: globalCn,
  login: loginCn,
  home: homeCn,
  alarm: alarmCn,
  device: deviceCn,
  org: orgCn,
  log: logCn,
  supervise: superviseCn,
  menu: menuCn,
  search: searchCn,
  columnCheck: columnCheck,
  setting: setting
}
export default ru